export default require('./Toolbar.react').default;
